import { ComponentType } from 'react'

// This file will be populated as we migrate pages
// For now, we'll create placeholder components and add real ones as we migrate

/**
 * Route Registry
 * Maps database route paths to React components
 * This must include ALL possible routes that can come from the database
 */
// Import migrated pages
import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import ForgotPassword from '@/pages/ForgotPassword'
import ResetPassword from '@/pages/ResetPassword'
import TwoFactor from '@/pages/TwoFactor'
import TwoFactorSetup from '@/pages/TwoFactor/Setup'
import Profile from '@/pages/Profile'
import ClientCheck from '@/pages/ClientCheck'
import CreatePassword from '@/pages/CreatePassword'
import MyRequests from '@/pages/Support/MyRequests'
import HelpCenter from '@/pages/HelpCenter'
import { RequestInfoModal } from '@/components/client/RequestInfoModal'

export const routeRegistry: Record<string, ComponentType<any>> = {
  // Public routes
  '/login': Login,
  '/forgot-password': ForgotPassword,
  '/reset-password': ResetPassword,
  '/two-factor': TwoFactor,
  '/two-factor/setup': TwoFactorSetup,
  '/client-check': ClientCheck,
  '/create-password': CreatePassword,

  // Dashboard (shared)
  '/dashboard': Dashboard,

  // Profile (shared)
  '/profile': Profile,

   //Client Routes

  // ============================================
  // CLIENT SUPPORT APPLICATION (support.actionlabs.com.ph)
  // ============================================
  '/my-request': MyRequests,
  '/my-request/:id': RequestInfoModal,

  '/help-center': HelpCenter,
}

/**
 * Get component for a route path
 * Handles dynamic segments (e.g., :id, :userId)
 */
export function getRouteComponent(path: string): ComponentType<any> | null {
  // Direct match
  if (routeRegistry[path]) {
    return routeRegistry[path]
  }

  // Try to match dynamic routes
  // e.g., "/categories/123" matches "/categories/:id"
  const dynamicPatterns = Object.keys(routeRegistry).filter(key => key.includes(':'))

  for (const pattern of dynamicPatterns) {
    const regex = new RegExp('^' + pattern.replace(/:[^/]+/g, '[^/]+') + '$')
    if (regex.test(path)) {
      return routeRegistry[pattern]
    }
  }

  return null
}

